import React from 'react';
import classnames from 'classnames';

class tile extends React.Component {

  constructor(props) {
    super(props);
    this.state = {      
      editing: false,
      newAmount: '',
      active: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.edit = this.edit.bind(this);
    this.save = this.save.bind(this);
  }

  edit() {
    this.setState({
      editing: true
    });
  }

  handleChange(e) {

    let value = e.target.value;
    if (value === 'on') {
      value = true;
    }
    if(this.props.checked === true){
      value = false;
    }

    this.props.handleChange(value, this.props.index);
  }

  renderEdit() {
    return (
      <div className="tile edit">
        <div className="tile-controls">
        </div>
        <div className="tile-content">
        <span className="tile-content--edit">
          How much cover do you need?
        </span>
        <input className="tile-content--input" onChange={this.props.update} type="text" />
        </div>
        <div className="tile-footer">
        <button onClick={this.save}>Save</button>
        </div>
    </div>
    )
  }

  save() {
    this.setState({
      editing: false,
      amount: this.state.amount
    });
  }

  getAmount() {
    if(this.props.amount != '' && this.props.adjustedAmount == undefined) {
      let amount = this.props.amount;
      return parseInt(amount).toLocaleString();
    } else {
      let amount = this.props.adjustedAmount;
      return parseInt(amount).toLocaleString();
    }

  }

  getProtectionLength() {
    if(this.props.item === 7) {
      return (this.props.insuranceInputs.itemsProtectionLength === 2 ? this.props.insuranceInputs.itemsProtectionLength + ' years' : '2 years');
    } else if(this.props.item === 8) {
      return (this.props.insuranceInputs.itemsProtectionLength === 5 ? this.props.insuranceInputs.itemsProtectionLength + ' years' : '5 years');
    } else if(this.props.item === 9) {
      return (this.props.insuranceInputs.itemsProtectionLength === 65 ? this.props.insuranceInputs.itemsProtectionLength : '65');
    } else if(this.props.item === 10) {
      return (this.props.insuranceInputs.itemsProtectionLength === 2 ? this.props.insuranceInputs.itemsProtectionLength : '2 years');
    }

  }


  renderNormal() {

    return (
      <div className={classnames('tile', {active: this.props.checked})}>

        <div className="tile-content">
        <div className="tile-content--amount">
        <span className="currency">$</span>
          {this.getAmount()}
          {
            this.props.tileType == 'ip'
            ? <span>/ month</span>
            : null
          }
        </div>
        <div className="tile-content--text">
        {
          this.props.tileType !== 'ip'
          ? <span>in cover will cost you</span>
          : null
        }
        {
          this.props.tileType === 'ip' && this.props.userInputs.police === '0'
          ? <span>{this.props.protectionLength === '65' ? 'until age ' : 'for up to ' }<strong>{this.getProtectionLength()}</strong> after a waiting period of <strong>{this.props.insuranceInputs.itemsWaitPeriod}</strong> days will cost you</span>
          : null
        }
        {
          this.props.tileType === 'ip' && this.props.userInputs.police === '1' && this.props.insuranceInputs.itemsProtectionLength === '2'
          ? <span>for up to <strong>2 years</strong> after a waiting period of <strong>180</strong> days will cost you</span>
          : null
        }
        </div>
        <div className="tile-content--premium-amount">
        ${this.props.results}
        </div>
        <div className="tile-content--premium-cycle">
        {this.props.frequency}
        </div>
        </div>
        <div className="tile-footer">
          <div className="tile-footer--checkbox">
            <input id={this.props.id} type="radio" checked={this.props.checked} name={this.props.tileType} onChange={this.handleChange}/>
            <label htmlFor={this.props.id}>Include in estimate</label>
          </div>
        </div>
    </div>
  );
  }

  render() {

    if (this.state.editing) {
      return this.renderEdit();
    } else {
      return this.renderNormal();
    }
  }
}

tile.defaultProps={
  checked: null,
  amount: 0
};

tile.propTypes = {
  insuranceInputs: React.PropTypes.shape({
      // itemsProtectionLength: React.PropTypes.string,
      // itemsWaitPeriod: React.PropTypes.string
    }),
    userInputs: React.PropTypes.shape({
      // title: React.PropTypes.string
      age: '',
      police: '',
      protectionLength: '',
      waitPeriod: ''
    }),
  item: React.PropTypes.number,
  tileType: React.PropTypes.string,
  // amount: React.PropTypes.number,
  id: React.PropTypes.number,
  // checked: React.PropTypes.bool,
  handleChange: React.PropTypes.func,
  index: React.PropTypes.number
};

export default tile;



// WEBPACK FOOTER //
// ./src/components/tiles/tile.js